export default __webpack_public_path__ + "static/media/profile2.c0b90f32.png";